import { render, staticRenderFns } from "./OrgWorkspaceIcon.vue?vue&type=template&id=3fd5a27a"
import script from "./OrgWorkspaceIcon.vue?vue&type=script&lang=js"
export * from "./OrgWorkspaceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports